import { ITrabalhador } from '../../Trabalhadores/models/trabalhador.model';
import { IApontamentoTrabalhador, IApontamentoTrabalhadorCreate, IMovimento } from '../models/apontamentostrabalhadores.model';
import { IRubricaApontamento } from '../../Apontamentos/models/rubricas.model';
import { TrabalhadoresService } from '../../Trabalhadores/trabalhadores.service';
import { ModalConfirmService } from '../../../shared/components/modal-confirm/modal.confirm.service';
import { RubricasPontoOverLoadService } from '../../Apontamentos/rubricaspontooverloadservice';

export class ApontamentosTrabalhadoresFormController {
    static $inject = [
        '$rootScope',
        '$scope',
        '$timeout',
        'NewToaster',
        'TrabalhadoresService',
        'ModalConfirmService',
        'RubricasPontoOverLoadService',
        'BuscaAvancadaService',
    ];

    public entity: IApontamentoTrabalhadorCreate;
    public apontamentos: IApontamentoTrabalhador[];
    public form: angular.IFormController;
    public visualizacao = false;

    public tipo: any;
    public tipoInicial: any;
    public dataPagamentoConfig = false;
    public entitiesTrabalhadores: ITrabalhador[];

    public descricoessituacao = [{
            situacao: -1,
            descricao: 'Rascunho'
        }, {
            situacao: 0,
            descricao: 'Pendente'
        }, {
            situacao: 1,
            descricao: 'Aprovado'
        }, {
            situacao: 2,
            descricao: 'Rejeitado'
        }, {
            situacao: 3,
            descricao: 'Calculado'
    }];

    constructor(
        public $rootScope: angular.IRootScopeService & {
            modoGestorPermissao: (arg: string) => boolean,
            session: any,
            nsjGlobals: any,
            tipo: any
        },
        public $scope: angular.IScope,
        public $timeout: angular.ITimeoutService,
        public NewToaster: { pop: Function },
        public trabalhadoresService: TrabalhadoresService,
        public ModalConfirmService: ModalConfirmService,
        public RubricasPontoOverLoadService: RubricasPontoOverLoadService,
        public BuscaAvancadaService: any,
    ) {
        this.tipoInicial = this.$rootScope.tipo;
        this.dataPagamentoConfig = this.$rootScope.nsjGlobals.a.configuracoes.MOVIMENTO_DATAPAGAMENTO ? true : false;

        if ($rootScope.session.entities.estabelecimento) {
            trabalhadoresService.constructors.estabelecimento = $rootScope.session.entities.estabelecimento.estabelecimento;
        }

        trabalhadoresService.constructors.tipo = this.tipo = this.tipoInicial;
        trabalhadoresService.constructors['forcagestor'] = ($rootScope.modoGestorPermissao('registrar_apontamento') || $rootScope.modoGestorPermissao('registrar_apontamento_grade'));
        trabalhadoresService.constructors['status'] = '00';

        this.entitiesTrabalhadores = trabalhadoresService.reload();

        $rootScope.$on('persona_trabalhadores_list_finished', (event: any, args: any) => {
            this.entitiesTrabalhadores = [...args];
        });

        $scope.$watch('$ctrl.entity', (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.form.$setDirty();
            }
        }, true);

        $scope.$watch('$ctrl.entity.trabalhador', (newValue?: ITrabalhador, oldValue?: ITrabalhador) => {
            if (newValue !== oldValue) {
                if (!newValue) {
                    this.entity.movimentos = [];
                    return;
                }
                this.getApontamentosTrabalhador(newValue.trabalhador);
            }
        }, true);
    }

    $onInit() {
        // se movimento já estiver salvo, precisa formatar rubrica para exibir código e nome corretamente
        if (this.entity?.movimentos?.length > 0) {
            this.entity.movimentos.forEach(movimento => {
                movimento.evento.codigo_nome = movimento.evento.codigo + ' - ' + movimento.evento.nome;
            });
        }

        if (!this.visualizacao && this.entity.trabalhador) {
            this.trabalhadoresService.get(this.entity.trabalhador.trabalhador);
            this.$scope.$on('persona_trabalhadores_loaded', (event, args) => {
                this.entity.trabalhador = args;
            });
        }
    }

    buscaAvancada() {
        this.trabalhadoresService.constructors.estabelecimento = this.$rootScope.session.entities.estabelecimento.estabelecimento;
        this.trabalhadoresService.constructors.tipo = this.tipo;
        delete this.trabalhadoresService.constructors.trabalhador;

        let columns = ['Nome', 'Tipo', 'Cargo', 'Departamento', 'Admissão'];
        let values = ['nome', 'tipo', 'cargo', 'departamento', 'dataadmissao'];
        let enumValues = [];
        enumValues['nome'] = '';
        enumValues['tipo'] = 'lookupTipoTrabalhador';
        enumValues['cargo'] = '';
        enumValues['departamento'] = '';
        enumValues['dataadmissao'] = 'date';
        this.trabalhadoresService.constructors['forcagestor'] = (this.$rootScope.modoGestorPermissao('registrar_apontamento') || this.$rootScope.modoGestorPermissao('registrar_apontamento_grade'));
        this.trabalhadoresService.constructors['status'] = '00';
        let modal = this.BuscaAvancadaService.open(self, this.entity, this.trabalhadoresService, columns, values, 'Colaboradores', enumValues, 'trabalhador', false, true, false, null);
        modal.result.then(() => {/* */ }).catch(() => {/* */ });
    }

    evento(event: angular.IAngularEvent & { detail: any }) {
        const constructorSearchList = {
            'estabelecimento': this.$rootScope.session.entities.estabelecimento.estabelecimento,
            'tipo': this.tipo,
            'status': '00',
            'forcagestor': (this.$rootScope.modoGestorPermissao('registrar_apontamento') || this.$rootScope.modoGestorPermissao('registrar_apontamento_grade'))
        };
        let filter: any = {};
        filter.search = event.detail.value;
        this.trabalhadoresService.constructors = constructorSearchList;
        this.trabalhadoresService.filter = event.detail;
        this.trabalhadoresService.search(filter);
    }

    eventoTipo() {
        const constructorSearchList = {
            'estabelecimento': this.$rootScope.session.entities.estabelecimento.estabelecimento,
            'tipo': this.tipo,
            'status': '00',
            'forcagestor': (this.$rootScope.modoGestorPermissao('registrar_apontamento') || this.$rootScope.modoGestorPermissao('registrar_apontamento_grade'))
        };
        this.trabalhadoresService.constructors = constructorSearchList;
        this.entitiesTrabalhadores = this.trabalhadoresService.reload();
    }

    retornaListagemCombo() {
        return this.entitiesTrabalhadores;
    }

    comboBusy() {
        return this.trabalhadoresService.loadParams.busy;
    }

    selecionaTrabalhador(event: angular.IAngularEvent & {
        detail: { value: IApontamentoTrabalhadorCreate['trabalhador'] }
    }) {
        if (!event) {
            return;
        }
        this.entity.trabalhador = event.detail.value;
    }

    limpaTrabalhador() {
        delete this.entity.trabalhador;
    }

    getApontamentosTrabalhador(trabalhador: string) {
        const apontamentos = this.apontamentos.find(apontamento => apontamento.trabalhador!.trabalhador === trabalhador);

        if (!apontamentos) {
            this.entity.movimentos = [];
            return;
        }

        apontamentos.movimentos.forEach(movimento => {
            this.RubricasPontoOverLoadService.setRubricaCodigoNome(movimento.evento);
        });
        this.entity.movimentos = apontamentos.movimentos ?? [];
    }

    possuiMovimentosPendentos(subentity: any) {
        let movimentosPendentes = false;
        if (subentity.movimentos) {
            subentity.movimentos.forEach((movimento: any, key: any) => {
                if (movimento.situacao !== -1) {
                    movimentosPendentes = true;
                }
            });
        }
        return movimentosPendentes;
    }

    verificaRubricaDuplicada(rubrica: IRubricaApontamento & { $$hashKey?: string }) {
        if (!rubrica || !this.entity || !this.entity.movimentos) {
            return;
        }

        const rubricaJaExiste = this.entity.movimentos.filter((movimento) =>
            (movimento.evento && (movimento.evento.codigo === rubrica.codigo)
        )).length;

        if (rubricaJaExiste > 1) {
            const text = {
                title: 'Confirmar rubrica',
                subtitle: 'Já existe um movimento com esta rubrica no período para o colaborador.',
                confirmText: 'Deseja continuar mesmo assim?',
                closeButton: 'Cancelar',
                confirmButton: 'Continuar',
            };
            const confirm = this.ModalConfirmService.open(this.entity, 'Movimentos', false, text);
            confirm.result.catch(() => {
                const rubricaDuplicada = this.entity.movimentos.find((movimento) => {
                    const evento = movimento.evento as (IRubricaApontamento & { $$hashKey?: string });
                    return evento.$$hashKey === rubrica.$$hashKey;
                });
                if (rubricaDuplicada && rubricaDuplicada.evento) {
                    rubricaDuplicada.evento = undefined;
                }
            });
        }
    }

    selectDtype(subentity: any, init: boolean = false) {
        if (!init) {
            subentity.conteudo = null;
        }
        subentity.dynamicType = this.testeRubrica(subentity);
        if (subentity.dynamicType === 'interval' && subentity.conteudo) {
            subentity.conteudo = Number(subentity.conteudo);
        }
        if (subentity.situacao == null) {
            subentity.situacao = -1;
        }
        // coloca a lotacao do colaborador por padrao ao adicionar um movimento
        if ((subentity.lotacao === undefined) &&
            (this.entity.trabalhador && typeof this.entity.trabalhador.lotacao === 'object')) {
            subentity.lotacao = this.entity.trabalhador.lotacao;
        } else if ((subentity.lotacao === undefined) &&
            (this.entity.trabalhador && this.entity.trabalhador.lotacaoobj)) {
            subentity.lotacao = this.entity.trabalhador.lotacaoobj;
        }
        // coloca a data de pagamento com a data atual por padrao ao adicionar um movimento
        if (subentity.datapagamento === undefined) {
            subentity.datapagamento = new Date();
        }
        // inicializando referencia com string vazia caso não tenha valor
        if (!subentity.referencia) {
            subentity.referencia = '';
        }
    }

    getEventoTipoValor(evento?: IMovimento['evento'] | IRubricaApontamento) {
        if (!evento) {
            return;
        }
        if ('evento_tipovalor' in evento) {
            return evento.evento_tipovalor;
        }
        return evento.tipovalor;
    }

    getEventoInformativo(evento?: IMovimento['evento'] | IRubricaApontamento) {
        if (!evento) {
            return;
        }
        if ('evento_informativa' in evento) {
            return evento.evento_informativa;
        }
        return evento.informativa;
    }

    forcaGestor() {
        return this.$rootScope.modoGestorPermissao('registrar_apontamento');
    }

    validarValorRubrica(rubrica: any) {
        // o ngChange é chamado antes que a model seja atualizada, por isso o uso do timeout
        this.$timeout(() => {
            if (rubrica.conteudo < 0) {
                rubrica.conteudo = 0;
            }
            let limiteerro = rubrica.evento.limiteerro;
            let limitealerta = rubrica.evento.limitealerta;
            let nome = rubrica.evento.nome;
            if (limiteerro > 0) {
                if (rubrica.conteudo > limiteerro) {
                    this.NewToaster.pop({
                        type: 'error',
                        title: 'Rubrica: ' + nome,
                        body: 'O valor máximo permitido para esta rubrica é ' + limiteerro + '.'
                    });
                    return;
                }
            }
            if (limitealerta > 0) {
                if (rubrica.conteudo > limitealerta) {
                    this.NewToaster.pop({
                        type: 'warning',
                        title: 'Rubrica: ' + nome,
                        body: 'O valor inserido é o maior que o limite de ' + limitealerta + '.'
                    });
                }
            }
        }, 0);
    }

    testeRubrica(rubrica: any) {
        let tipo;
        if (rubrica.evento) {
            if (rubrica.evento.evento_unidade != null) {
                tipo = rubrica.evento.evento_unidade;
            }
            if (rubrica.evento.unidade && typeof rubrica.evento.unidade !== 'undefined') {
                tipo = rubrica.evento.unidade;
            }
        }

        switch (tipo) {
            case 0:
            case 8:
            case 10:
                return 'interval';
            case 1:
                return 'number';
            case 2:
                return 'currency';
            default:
                return 'number-only-short';
        }
    }
}
